export default __webpack_public_path__ + "static/visualise-performance-f3e8cf6c2d55182fd131be96a5f02178.mp4";